var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStructureStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_1184)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4001 60C30.4001 54.4772 34.8773 50 40.4001 50H160.4C165.923 50 170.4 54.4772 170.4 60V140C170.4 145.523 165.923 150 160.4 150H40.4002C34.8773 150 30.4001 145.523 30.4001 140V60Z",
    fill: "url(#paint1_linear_26801_1184)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4001 72C42.4001 69.7909 44.191 68 46.4001 68H73.4001C75.6093 68 77.4001 69.7909 77.4001 72V88C77.4001 90.2091 75.6093 92 73.4001 92H46.4001C44.191 92 42.4001 90.2091 42.4001 88V72Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.4 71H89.4001C88.8479 71 88.4001 71.4477 88.4001 72V88C88.4001 88.5523 88.8479 89 89.4001 89H154.4C154.952 89 155.4 88.5523 155.4 88V72C155.4 71.4477 154.952 71 154.4 71ZM89.4001 68C87.191 68 85.4001 69.7909 85.4001 72V88C85.4001 90.2091 87.191 92 89.4001 92H154.4C156.609 92 158.4 90.2091 158.4 88V72C158.4 69.7909 156.609 68 154.4 68H89.4001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4001 113C42.4001 110.791 44.191 109 46.4001 109H73.4001C75.6093 109 77.4001 110.791 77.4001 113V129C77.4001 131.209 75.6093 133 73.4001 133H46.4001C44.191 133 42.4001 131.209 42.4001 129V113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.4 112H89.4001C88.8479 112 88.4001 112.448 88.4001 113V129C88.4001 129.552 88.8479 130 89.4001 130H154.4C154.952 130 155.4 129.552 155.4 129V113C155.4 112.448 154.952 112 154.4 112ZM89.4001 109C87.191 109 85.4001 110.791 85.4001 113V129C85.4001 131.209 87.191 133 89.4001 133H154.4C156.609 133 158.4 131.209 158.4 129V113C158.4 110.791 156.609 109 154.4 109H89.4001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4001 63.5C91.4001 62.6716 92.0717 62 92.9001 62H100.9C101.729 62 102.4 62.6716 102.4 63.5C102.4 64.3284 101.729 65 100.9 65H98.1649V94H100.9C101.729 94 102.4 94.6716 102.4 95.5C102.4 96.3284 101.729 97 100.9 97H92.9001C92.0717 97 91.4001 96.3284 91.4001 95.5C91.4001 94.6716 92.0717 94 92.9001 94H95.1649V65H92.9001C92.0717 65 91.4001 64.3284 91.4001 63.5Z",
    fill: "url(#paint2_linear_26801_1184)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.4 84.5C101.4 83.6716 102.072 83 102.9 83H113.9C114.729 83 115.4 83.6716 115.4 84.5C115.4 85.3284 114.729 86 113.9 86H102.9C102.072 86 101.4 85.3284 101.4 84.5ZM118.4 84.5C118.4 83.6716 119.072 83 119.9 83H130.9C131.729 83 132.4 83.6716 132.4 84.5C132.4 85.3284 131.729 86 130.9 86H119.9C119.072 86 118.4 85.3284 118.4 84.5ZM135.9 83C135.072 83 134.4 83.6716 134.4 84.5C134.4 85.3284 135.072 86 135.9 86H146.9C147.729 86 148.4 85.3284 148.4 84.5C148.4 83.6716 147.729 83 146.9 83H135.9Z",
    fill: "url(#paint3_linear_26801_1184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1184",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1184",
    x1: 100.4,
    y1: 50,
    x2: 100.4,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1184",
    x1: 92.6033,
    y1: 62,
    x2: 109.614,
    y2: 65.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1184",
    x1: 106.541,
    y1: 83,
    x2: 107.324,
    y2: 90.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureStrip);
export default __webpack_public_path__ + "static/media/Structure-Strip.4e9b68efa560f1bac2c2f7450206248d.svg";
export { ForwardRef as ReactComponent };